import { combineReducers } from 'redux'
import relationships from './relationships'
import genders from './genders'
import patients from './patients'
import appointments from './appointments'
import physicians from './physicians'
import serviceAreas from './serviceAreas'
import cpt4Codes from './cpt4Codes'
import configuration from './configuration'
import configurationLogo from './configurationLogo'

export const referencesReducer = combineReducers({
  relationships,
  genders,
  patients,
  appointments,
  physicians,
  serviceAreas,
  cpt4Codes,
  configuration,
  configurationLogo
})

export default referencesReducer
